export default "__VITE_ASSET__36c77b17__"